import React from 'react';
import { Text } from 'components/text/Text';
import { RichText } from 'components/rich-text/RichText';

export const TextSlice = ({
  tagline,
  title,
  heading,
  text,
  columns,
  color,
  image,
  link,
  label,
  aside,
  isSlice,
  isSplitPage,
  isArticle,
  isEvent,
  isProduct,
}) => {
  const titleLength = RichText.asText(heading)?.length || 0;
  const asideLength = RichText.asText(aside)?.length || 0;

  return (
    <Text
      aside={asideLength > 0 ? RichText.render(aside) : undefined}
      tagline={tagline}
      titleLength={titleLength}
      title={RichText.render(heading)}
      colCount={columns}
      text={RichText.render(text)}
      color={color}
      image={image}
      link={link}
      label={label}
      isSlice={isSlice}
      isSplitPage={isSplitPage}
      isArticle={isArticle}
      isEvent={isEvent}
      isProduct={isProduct}
    />
  );
};

export default TextSlice;
